import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/safety", label: "Safety Center" },
  { to: "/become-a-coach", label: "Become a Conversation Coach" },
  { to: "/become-celeb", label: "Become an Instafrnd Celeb" },
  { to: "/celeb-connect", label: "Celeb Connect Form" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="nav-in">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <img src={logo} alt="Instafrnd" className="brand-logo" style={{ borderRadius: 6 }} />
        </Link>

        <div className="nav-links">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}>
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="nav-spacer" />

        <div className="nav-desktop-actions">
          <button className="nav-login">Login</button>
          <button className="btn btn-coin">◈ Recharge Coins</button>
          <button className="btn btn-primary">Download</button>
        </div>

        <button
          className="nav-burger"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "✕" : "☰"}
        </button>
      </div>

      {open && (
        <div className="nav-mobile">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          <div className="nav-mobile-actions">
            <button className="btn btn-coin">◈ Recharge Coins</button>
            <button className="btn btn-primary">Download</button>
          </div>
        </div>
      )}
    </nav>
  );
}
